import { styled } from "@mui/material/styles";

export const StyledInput = styled("input")(({ theme }) => ({
  border: "#fff 2px solid",
  borderRadius: "8px",
  fontFamily: "inherit",
  padding: "15px",
  color: "#717680",
  fontSize: "16px",
  transition: "all 0.2s ease-in",
  appearance: "none",

  '&[type="number"]': {
    width: "100px",
    textAlign: "right",
    "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
      WebkitAppearance: "none",
      margin: 0,
    },
    "&[type=number]": {
      MozAppearance: "textfield", // Firefox
    },
  },

  // 🎯 Checkbox input
  '&[type="checkbox"]': {
    margin: 0,
    width: "25px",
    height: "25px",
    padding: "5px",
    border: "0.1em solid #fff",
    borderRadius: "0.15em",
    transform: "translateY(-0.075em)",
    placeContent: "center",
    cursor: "pointer",
    "&:before": {
      content: '""',
      width: "12px",
      height: "12px",
      clipPath: "polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%)",
      transform: "scale(0)",
      transformOrigin: "bottom left",
      transition: "120ms transform ease-in-out",
      boxShadow: `inset 1em 1em ${theme.palette.background.button_primary}`,
      backgroundColor: "red",
      display: "block"
    },
    "&:checked": {
      "&:before": {
        transform: "scale(1)"
      }
    }
  },

  // 🎯 Text input (default)
  '&[type="text"], &[type="password"], &[type="email"]': {
    width: "100%",
    "&:focus": {
      outline: "none",
      border: `${theme.palette.background.button_primary} 2px solid`,
    },
    "&.invalid-input": {
      border: `${theme.palette.text.warning_primary} 2px solid`,
    },
  },
  // 🎯 Email input
  '&[type="email"]': {
    width: "100%",
  },
}));
